<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.attendance'),
                        href: null,
                    },
                    {
                        name: date,
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex justify-between items-center">
            <div class="flex space-x-2 items-center">
                <NavLinks :links="meta.navDaysLinks" />
            </div>
        </div>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 md:grid-cols-12">
                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.date')" for="date" />
                        <FormInput required id="date" v-model="form.date" name="date" type="date" class="w-full mt-1" />
                        <FormError :value="form.errors.date" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                    <div class="mt-1">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 mt-5">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.name') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(student, index) in students"
                                :key="student.id"
                            >
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <div class="flex gap-x-1 items-center">
                                        <span
                                            class="m-1 inline-block shrink-0 w-2.5 h-2.5 rounded-full"
                                            :class="[student.checked_at ? 'bg-green-400' : 'bg-gray-400']"
                                        />
                                        <InertiaLink :href="student.url" class="text-indigo-500">
                                            {{ student.full_name }}
                                        </InertiaLink>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import NavLinks from '@/components/NavLinks.vue';
import { Link as InertiaLink } from '@inertiajs/vue3';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        InertiaLink,
        PanelPage,
        FormInput,
        FormLabel,
        FormError,
        NavLinks,
    },
    props: ['meta', 'filters', 'students', 'date'],
    layout: Layout,
    data() {
        return {
            form: this.$inertia.form({
                date: this.filters.date,
            }),
        };
    },
    name: 'Index',
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
